import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { InitiativeIcon } from './InitiativeIcon';
import { InitiativeName } from './InitiativeName';

export class InitiativeFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [InitiativeIcon, InitiativeName];
  }

  get title() {
    return terminology('Initiative');
  }
}
